export default "__VITE_ASSET__5d2194ad__"